import Modal from "react-bootstrap/Modal";
import React from "react";
import {isPresent} from "../../utils/utils";
import FlawsInspector from "./FlawsInspector";


const FlawsInspectorModal = ({ defects, flawsToInspect, setFlawsToInspect }) => {

  return <Modal show={isPresent(flawsToInspect)} onHide={() => setFlawsToInspect(null)} animation={false} id="flaws-inspector-modal">
    <Modal.Body>
      <div className="w-100 d-flex justify-content-end mb-5">
        <i className="fas fa-xmark fa-lg color-gray color-black-on-hover cursor-pointer"
           onClick={() => setFlawsToInspect(null)}
        />
      </div>

      <FlawsInspector
        defects={defects}
        flaws={flawsToInspect}
        setFlaws={setFlawsToInspect}
      />
    </Modal.Body>
  </Modal>
};

export default FlawsInspectorModal;